"use strict";

var _interopRequireWildcard = require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireWildcard.js").default;

var _interopRequireDefault = require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.function.name.js");

var _regeneratorRuntime2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/regeneratorRuntime.js"));

var _asyncToGenerator2 = _interopRequireDefault(require("C:/Projects/008-QLK_FE/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/asyncToGenerator.js"));

var productApi = _interopRequireWildcard(require("@/api/product"));

var _imeiReceive = require("@/api/imei-receive");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var rule = {
  required: true,
  message: "Required",
  trigger: "submit"
};
var _default = {
  data: function data() {
    return {
      form: {
        cause: "",
        name: ""
      },
      visible: false,
      rules: {
        cause: rule,
        name: rule
      },
      imeis: [],
      loading: false
    };
  },
  methods: {
    submitData: function submitData() {
      var _this = this;

      return (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee() {
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$refs.form.validate();

              case 3:
                _this.loading = true;
                _context.next = 6;
                return productApi.removeImei({
                  cause: _this.form.cause,
                  imei: _this.imeis
                });

              case 6:
                _context.next = 8;
                return _imeiReceive.imeiReceiveApi.create({
                  imeis: _this.imeis,
                  name: _this.form.name
                });

              case 8:
                _this.$message({
                  type: "success",
                  message: "Remove successfully (".concat(_this.imeis.length, " imeis)")
                });

                _this.visible = false;

                _this.$emit("submit:ok");

              case 11:
                _context.prev = 11;
                _this.loading = false;
                return _context.finish(11);

              case 14:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[0,, 11, 14]]);
      }))();
    },
    handleOpen: function handleOpen(imeis) {
      this.imeis = imeis;
      this.visible = true;
      this.form = {
        name: "",
        cause: "Auto - Receive phone"
      };
    }
  }
};
exports.default = _default;